<template>
  <page :title="title" :breadcrumb="breadcrumb">
    <div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="tranMode === 'New'">mdi-plus</v-icon>
          <v-icon v-if="tranMode === 'Review'">mdi-pencil</v-icon>
          <v-icon v-if="tranMode === 'Query'">mdi-magnify</v-icon>
          <v-toolbar-title v-if="tranMode === 'New'">New Motor Vehicle Model</v-toolbar-title>
          <v-toolbar-title v-if="tranMode === 'Review'">Edit Motor Vehicle Model</v-toolbar-title>
          <v-toolbar-title v-if="tranMode === 'Query'">View Motor Vehicle Model</v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text>
          <message :messages="messages"></message>
          <form>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs6 v-if="tranMode === 'New'">
                  <v-autocomplete
                    v-model="form.vehMake"
                    :label="labels.vehMake"
                    :items="makeList"
                    item-text="label"
                    item-value="value"
                    :error-messages="errors.collect('vehMake')"
                    data-vv-name="vehMake"
                    :data-vv-as="labels.vehMake"
                    v-validate="'required'"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{ labels.vehMake }}</v-subheader>
                  <div class="queryValue">{{ form.vehMakeDesc }}</div>
                </v-flex>
                <v-flex xs6 v-if="tranMode === 'New'">
                  <v-text-field
                    v-model="form.vehModel"
                    :label="labels.vehModel"
                    :error-messages="errors.collect('paramVehModel')"
                    data-vv-name="paramVehModel"
                    :data-vv-as="labels.vehModel"
                    v-validate="'required|param|max:10'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{ labels.vehModel }}</v-subheader>
                  <div class="queryValue">{{ form.vehModel }}</div>
                </v-flex>
                <v-flex xs6 v-if="tranMode !== 'Query'">
                  <v-text-field
                    v-model="form.vehModelDesc"
                    :label="labels.vehModelDesc"
                    :error-messages="errors.collect('vehModelDesc')"
                    data-vv-name="vehModelDesc"
                    :data-vv-as="labels.vehModelDesc"
                    v-validate="'required|entry|max:100'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{ labels.vehModelDesc }}</v-subheader>
                  <div class="queryValue">{{ form.vehModelDesc }}</div>
                </v-flex>
                <v-flex xs6 v-if="tranMode !== 'Query'">
                  <v-autocomplete
                    v-model="form.vehGrp"
                    :label="labels.vehGrp"
                    :items="groupList"
                    item-text="label"
                    item-value="value"
                    :error-messages="errors.collect('vehGrp')"
                    data-vv-name="vehGrp"
                    :data-vv-as="labels.vehGrp"
                    v-validate="'required'"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{ labels.vehGrp }}</v-subheader>
                  <div class="queryValue">{{ form.vehGrpDesc }}</div>
                </v-flex>
                <v-flex xs6 v-if="tranMode !== 'Query'">
                  <v-autocomplete
                    v-model="form.prmtStts"
                    :label="labels.prmtStts"
                    :items="permitStatusList"
                    item-text="label"
                    item-value="value"
                    :error-messages="errors.collect('prmtStts')"
                    data-vv-name="prmtStts"
                    :data-vv-as="labels.prmtStts"
                    v-validate="'required'"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{ labels.prmtStts }}</v-subheader>
                  <div class="queryValue">{{ form.prmSttsName }}</div>
                </v-flex>
                <v-flex xs6 v-if="tranMode !== 'Query'">
                  <v-text-field
                    v-model="form.engineCc"
                    :label="labels.engineCc"
                    :error-messages="errors.collect('engineCc')"
                    data-vv-name="engineCc"
                    :data-vv-as="labels.engineCc"
                    v-validate="'integer|max:10|required'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{ labels.engineCc }}</v-subheader>
                  <div class="queryValue">{{ form.engineCc }}</div>
                </v-flex>
                <v-flex xs6 v-if="tranMode !== 'Query'">
                  <v-text-field
                    v-model="form.tonnage"
                    :label="labels.tonnage"
                    :error-messages="errors.collect('tonnage')"
                    data-vv-name="tonnage"
                    :data-vv-as="labels.tonnage"
                    v-validate="'decimal|max:10|required'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{ labels.tonnage }}</v-subheader>
                  <div class="queryValue">{{ form.tonnage }}</div>
                </v-flex>
                <v-flex xs6 v-if="tranMode !== 'Query'">
                  <v-text-field
                    v-model="form.noSeats"
                    :label="labels.noSeats"
                    :error-messages="errors.collect('noSeats')"
                    data-vv-name="noSeats"
                    :data-vv-as="labels.noSeats"
                    v-validate="'numeric|max:2|required'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{ labels.noSeats }}</v-subheader>
                  <div class="queryValue">{{ form.noSeats }}</div>
                </v-flex>
                <v-flex xs6 v-if="tranMode !== 'Query'">
                  <v-text-field
                    v-model="form.manufYr"
                    :label="labels.manufYr"
                    :error-messages="errors.collect('manufYr')"
                    data-vv-name="manufYr"
                    :data-vv-as="labels.manufYr"
                    v-validate="'numeric|max:4'"
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{ labels.manufYr }}</v-subheader>
                  <div class="queryValue">{{ form.manufYr }}</div>
                </v-flex>
                <v-flex xs6 v-if="tranMode !== 'Query'">
                  <v-autocomplete
                    v-model="form.bodyType"
                    :label="labels.bodyType"
                    :items="bodyTypeList"
                    item-text="label"
                    item-value="value"
                    :error-messages="errors.collect('bodyType')"
                    data-vv-name="bodyType"
                    :data-vv-as="labels.bodyType"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{ labels.bodyType }}</v-subheader>
                  <div class="queryValue">{{ form.bodyTypeDesc }}</div>
                </v-flex>
                <v-flex xs6 v-if="tranMode !== 'Query'">
                  <v-text-field
                    v-model="form.purchasePrice"
                    :label="labels.purchasePrice"
                    :error-messages="errors.collect('purchasePrice')"
                    data-vv-name="purchasePrice"
                    :data-vv-as="labels.purchasePrice"
                    v-validate="'decimal|max:7'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{ labels.purchasePrice }}</v-subheader>
                  <div class="queryValue">{{ form.purchasePrice }}</div>
                </v-flex>
                <v-flex xs6 v-if="tranMode !== 'Query'">
                  <v-text-field
                    v-model="form.defPriceUom"
                    :label="labels.defPriceUom"
                    :error-messages="errors.collect('defPriceUom')"
                    data-vv-name="defPriceUom"
                    :data-vv-as="labels.defPriceUom"
                    v-validate="'integer|max:7'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{ labels.defPriceUom }}</v-subheader>
                  <div class="queryValue">{{ form.defPriceUom }}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                  <div class="queryValue">{{ form.createdBy }}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                  <div class="queryValue">{{ formatDisplayDate(form.createdDate) }}</div>
                </v-flex>
                <v-flex xs6 v-if="tranMode !== 'New'">
                  <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                  <div class="queryValue">{{ form.modifiedBy }}</div>
                </v-flex>
                <v-flex xs6 v-if="tranMode !== 'New'">
                  <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                  <div class="queryValue">{{ formatDisplayDate(form.modifiedDate) }}</div>
                </v-flex>
              </v-layout>
            </v-container>
          </form>
        </v-card-text>
        <v-flex xs12 row warp>
          <v-btn color="error" dark class=" mr-2" @click.prevent="doCancel">Cancel<v-icon dark right>mdi-cancel</v-icon></v-btn>
          <v-btn v-if="tranMode !== 'Query'" color="primary" type="submit" @click.prevent="doSave()">
            Save
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </v-flex>
      </v-card>
    </div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import FieldMixin from '@/mixins/field'
import { formatDisplayDate } from '@/utils/date'
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      breadcrumb: [],
      title: 'Motor Vehicle Model',
      labels: {
        vehModel: 'Model Code',
        vehModelDesc: 'Model Description',
        bodyType: 'Body Type',
        vehGrp: 'Vehicle Group',
        vehMake: 'Make',
        engineCc: 'Engine CC',
        tonnage: 'Tonnage',
        noSeats: 'No. Seats',
        manufYr: 'Manufacture Year',
        purchasePrice: 'Purchase Price',
        defPriceUom: 'Default Price UOM',
        prmtStts: 'Permit Status',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        vehModel: '',
        vehModelDesc: '',
        bodyType: undefined,
        bodyTypeDesc: '',
        vehGrp: undefined,
        vehGrpDesc: '',
        vehMake: undefined,
        vehMakeDesc: '',
        engineCc: null,
        tonnage: null,
        noSeats: null,
        manufYr: null,
        purchasePrice: null,
        defPriceUom: null,
        prmtStts: '',
        prmSttsName: '',
        createdBy: '',
        createdDate: null,
        modifiedBy: '',
        modifiedDate: null,
        actionName: ''
      },
      loading: false
    }
  },
  computed: {
    ...mapGetters(['derieveBreadcrumbByName']),
    menu() {
      return this.$store.state.uwMotorParam.menu
    },
    permitStatusList() {
      return this.$store.state.uwMotorParam.permitStatusList
    },
    bodyTypeList() {
      return this.$store.state.uwMotorParam.bodyTypeList
    },
    makeList() {
      return this.$store.state.uwMotorParam.makeList
    },
    groupList() {
      return this.$store.state.uwMotorParam.groupList
    },
    tranMode() {
      return this.$route.params.tranMode
    },
    vehModel() {
      return this.$route.params.vehModel
    },
    vehMake() {
      return this.$route.params.vehMake
    }
  },
  methods: {
    formatDisplayDate(effDate) {
      return formatDisplayDate(effDate)
    },
    doInitForm() {
      this.resetValidator()
      this.resetMessages()
      this.form.vehModel = ''
      this.form.bodyType = undefined
      this.form.vehGrp = undefined
      this.form.vehMake = undefined
      this.form.bodyTypeDesc = ''
      this.form.vehGrpDesc = ''
      this.form.vehMakeDesc = ''
      this.form.engineCc = null
      this.form.tonnage = null
      this.form.noSeats = null
      this.form.manufYr = null
      this.form.purchasePrice = null
      this.form.defPriceUom = null
      this.form.prmtStts = ''
      this.form.prmSttsName = ''
      this.form.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.form.createdDate = new Date()
      this.form.modifiedBy = ''
      this.form.modifiedDate = null
      this.form.actionName = ''
    },
    async fetchData() {
      this.loading = true
      const apiURI = this.menu.motorParam
      const expand = { paramKey: 'mtrVehModel', paramString: this.vehModel, paramRefOrPrmtStts: this.vehMake }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (data) {
          this.form.vehModel = data.motorParam.paramVehModel
          this.form.vehModelDesc = data.motorParam.paramDesc
          this.form.bodyType = data.motorParam.paramBodyType
          this.form.vehGrp = data.motorParam.paramVehGrp
          this.form.vehMake = data.motorParam.paramVehMake
          this.form.bodyTypeDesc = data.motorParam.paramBodyTypeDesc
          this.form.vehGrpDesc = data.motorParam.paramVehGrpDesc
          this.form.vehMakeDesc = data.motorParam.paramVehMakeDesc
          this.form.engineCc = data.motorParam.paramEngineCc
          this.form.tonnage = data.motorParam.paramTonnage
          this.form.noSeats = data.motorParam.paramNoSeats
          this.form.manufYr = data.motorParam.paramManufYr
          this.form.purchasePrice = data.motorParam.paramPurchasePrice
          this.form.defPriceUom = data.motorParam.paramDefPriceUom
          this.form.prmtStts = data.motorParam.paramPrmtStts
          this.form.prmSttsName = data.motorParam.paramPrmtSttsName
          this.form.createdBy = data.motorParam.createdBy
          this.form.createdDate = data.motorParam.createdDate
          this.form.modifiedBy = data.motorParam.modifiedBy
          this.form.modifiedDate = data.motorParam.modifiedDate
        }
      }
      this.loading = false
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        this.loading = true
        if (result) {
          if (this.tranMode === 'New') {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
        this.loading = false
      })
    },
    async doCreate() {
      const apiURI = this.menu.performActionMtrModel
      if (apiURI) {
        this.submitting = true
        try {
          const expand = {
            paramName: this.form.vehModel,
            paramRef: this.form.vehMake,
            paramVehModel: this.form.vehModel,
            paramDesc: this.form.vehModelDesc,
            paramBodyType: this.form.bodyType,
            paramVehGrp: this.form.vehGrp,
            paramVehMake: this.form.vehMake,
            paramEngineCc: this.form.engineCc,
            paramTonnage: this.form.tonnage,
            paramNoSeats: this.form.noSeats,
            paramManufYr: this.form.manufYr,
            paramPurchasePrice: this.form.purchasePrice,
            paramDefPriceUom: this.form.defPriceUom,
            paramPrmtStts: this.form.prmtStts,
            paramType: 'mtrVehModel',
            actionName: 'CREATE'
          }
          const result = await this.$http.post(apiURI, expand)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          this.submitting = false
          this.$router.push({ name: 'mtrVehModel' })
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doUpdate() {
      const apiURI = this.menu.performActionMtrModel
      if (apiURI) {
        this.submitting = true
        try {
          const expand = {
            paramName: this.vehModel,
            paramRef: this.vehMake,
            paramVehModel: this.form.vehModel,
            paramDesc: this.form.vehModelDesc,
            paramBodyType: this.form.bodyType,
            paramVehGrp: this.form.vehGrp,
            paramVehMake: this.form.vehMake,
            paramEngineCc: this.form.engineCc,
            paramTonnage: this.form.tonnage,
            paramNoSeats: this.form.noSeats,
            paramManufYr: this.form.manufYr,
            paramPurchasePrice: this.form.purchasePrice,
            paramDefPriceUom: this.form.defPriceUom,
            paramPrmtStts: this.form.prmtStts,
            paramType: 'mtrVehModel',
            actionName: 'UPDATE'
          }
          const result = await this.$http.post(apiURI, expand)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          this.submitting = false
          this.$router.push({ name: 'mtrVehModel' })
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doClose() {
      this.doInitForm()
    },
    doCancel() {
      this.$router.push({ name: 'mtrVehModel' })
    }
  },
  created() {
    this.breadcrumb = this.derieveBreadcrumbByName('mtrVehModel')
    this.breadcrumb.push({
      name: 'mtrVehModelReview',
      text: this.title
    })
    if (this.tranMode === 'New') {
      this.doInitForm()
    } else {
      this.fetchData()
    }
  },
  mixins: [MessageMixin, FieldMixin]
}
</script>
